module.exports = __webpack_public_path__ + "img/button-bg.8f72941.png";